import React from "react";

/** Animated gold/cyan camera aperture used as decorative motif. */
export const Aperture = ({ size = 360, className = "" }) => {
  const blades = Array.from({ length: 8 });
  return (
    <svg
      width={size}
      height={size}
      viewBox="-100 -100 200 200"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="lensGlow" cx="0" cy="0" r="90" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#00E5FF" stopOpacity="0.18" />
          <stop offset="60%" stopColor="#D4AF37" stopOpacity="0.06" />
          <stop offset="100%" stopColor="#000" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Soft inner glow */}
      <circle r="92" fill="url(#lensGlow)" />

      {/* Outer ring */}
      <circle r="88" fill="none" stroke="#D4AF37" strokeOpacity="0.55" strokeWidth="0.6" />
      <circle r="82" fill="none" stroke="#D4AF37" strokeOpacity="0.18" strokeWidth="0.4" strokeDasharray="2 4" />

      {/* Aperture blades */}
      <g className="aperture-spin">
        {blades.map((_, i) => {
          const angle = (i * 360) / blades.length;
          return (
            <g key={i} transform={`rotate(${angle})`}>
              <path
                d="M 0 -78 L 38 -22 L 0 6 Z"
                fill="#D4AF37"
                fillOpacity="0.08"
                stroke="#D4AF37"
                strokeOpacity="0.7"
                strokeWidth="0.5"
              />
            </g>
          );
        })}
      </g>

      {/* Counter-rotating thin reticle */}
      <g className="aperture-spin-rev">
        <circle r="60" fill="none" stroke="#00E5FF" strokeOpacity="0.25" strokeWidth="0.3" strokeDasharray="1 6" />
        <line x1="-72" y1="0" x2="-58" y2="0" stroke="#D4AF37" strokeOpacity="0.6" />
        <line x1="72" y1="0" x2="58" y2="0" stroke="#D4AF37" strokeOpacity="0.6" />
        <line x1="0" y1="-72" x2="0" y2="-58" stroke="#D4AF37" strokeOpacity="0.6" />
        <line x1="0" y1="72" x2="0" y2="58" stroke="#D4AF37" strokeOpacity="0.6" />
      </g>

      {/* Center iris */}
      <circle r="14" fill="#060606" stroke="#D4AF37" strokeWidth="0.8" />
      <circle r="4" fill="#00E5FF" fillOpacity="0.85" />
    </svg>
  );
};

export default Aperture;
